/* eslint-disable react/sort-comp */
/* eslint-disable react/no-danger */
/* eslint-disable no-await-in-loop */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Nav, NavItem, NavLink } from 'reactstrap';
import SignatureCanvas from 'react-signature-canvas';
import PropTypes from 'prop-types';
import RandExp from 'randexp';
import { connect } from 'react-redux';
import moment from 'utils/moment';
import Button from '../../components/button';
import styles from './forms.module.scss';
import DefaultFields from './components/DefaultFields';
import PulpoField from '../../pulpo_visualizer/fields';
import FormSubmitted from './components/FormSubmitted';
import Collapsible from '../../components/collapsible/Collapsible';
import Loading from '../../components/loading';
import Attachments from './components/Attachments';
import MultiColumnGrid from './MultiColumnGrid';
import FormattedMessageWithClass from '../../components/formattedMessageWithClass';
import { isLocal, hostName } from '../../constants/apiEnv';
import { GetFileName, S3Uploads } from '../services';
import DetailsStyles from '../../components/customFields/customField.module.scss';
import TooltipWithHeading from '../../components/helpToolTip/ToolTip';
import { getFieldCalculation, getFieldError, getPhoneConvert, handleMultiFieldErrorList, getHasMapLocation } from './utils/helpers';
import Annotations from '../../components/Annotations/Annotation';
import MultiLevelLocation from '../../pulpo_visualizer/fields/multi-level-location/MultiLevelLocation';
import CollapsibleSections from '../../components/customFields/CollapsibleSections';
import { runCumulativeCalculation } from '../../components/customFields/runcumulativecalculation';
import {
  DATE_SUBMIT_FIELD_TYPES,
  TIME_FIELD_TYPES,
  getFieldUsesSeconds,
  normalizeSubmittedDateValue
} from '../../utils/helpers';

const url = hostName.slice(6);

const handleMultiGridSpecificFieldError = (field, formValues, handleMultiColumnGLS, form_data) => {
  let errorData = [];
  let isConditionallyVisible = true;
  if (field.conditional_field) {
    const conditionValues = field?.conditional_values;
    let fieldValue = form_data[field.conditional_field?.key];
    if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
    if (typeof fieldValue === 'object' && fieldValue?.level_0) {
      isConditionallyVisible = Object.values(fieldValue)?.filter(value => value !== '')?.join()
        === Object.values(conditionValues[0])?.filter(value => value !== '')?.join();
    } else {
      isConditionallyVisible = conditionValues.some(value => fieldValue?.includes(value?.value));
    }
  }
  Object.entries(field.multiple_fields).forEach(([key, config]) => {
    if (isConditionallyVisible) {
      const isMandatory = config.mandatory_multi_field;
      const value = formValues[key];
      const fieldType = config?.type?.key;

      const isEmpty = value === null
        || value === undefined
        || value === ''
        || (Array.isArray(value) && value.length === 0);

      const field_type = fieldType === 'string' ? config?.validator : config?.inputType;
      const max_min = field_type || {};
      let errorMinMax = false;
      if (max_min?.type === 'min_max') {
        const length = value?.length ?? 0;
        const min = max_min?.minValue && +max_min?.minValue;
        const max = max_min?.maxValue && +max_min?.maxValue;

        if (min && length < min) {
          errorMinMax = true;
        } else if (max && length > max) {
          errorMinMax = true;
        }
      }

      if (isMandatory && isEmpty && config?.type?.key !== 'dataSource-ds6') {
        errorData.push(config.title);
      } else if (isMandatory && config?.type?.key === 'dataSource-ds8') {
        const showError = handleMultiColumnGLS(key, config, value);
        if (showError) {
          errorData.push(config.title);
        }
      } else if (['string', 'number'].includes(fieldType) && !isEmpty && errorMinMax) {
        errorData.push(config.title);
      }
    }
  });
  return errorData;
};

class NewFormAnswer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFormErrors: false,
      answers: {},
      apiStatus: undefined,
      message: undefined,
      publicFiledValidations: {},
      loadingStatus: false,
      attachmentFields: [],
      signatureFields: [],
      errorsList: {},
      stateInit: true,
      form_response: {},
      active_tab: 'form_entry',
      searchStatusQuery: '',
      publicFormData: {},
      trackingId: '',
      formStatusMessage: '',
      errorListMCG: {}
    };
    const { match: { params: { id } } } = props;
    localStorage.setItem('portalBackendId', id);
    this.publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${id}${url}/public`;
    this.sigCanvas = new Map();
  }

  async componentDidMount() {
    const { match: { params: { formKey } } } = this.props;
    try {
      this.setState({ loadingStatus: true });
      await fetch(`${this.publicUrl}/forms/parent/${formKey}`)
        .then(response => response.json())
        .then((data) => {
          let requiredMap = {};
          let fieldErrors = {};
          let errorListMCG = {};
          const conditionalFields = {};
          const attachmentFields = [];
          let temp = {};
          const signatureFields = [];
          let placeHolders = {};
          const fields = data?.form?.schema?.fields?.length > 0 && data?.form?.schema?.fields?.filter(field => field?.internal !== true
             && field?.type !== 'page_break' && !field?.settings?.disable_for_public) || [];
          if (fields?.length > 0) {
            fields.forEach((detailField) => {
              const dafultValues = detailField?.settings?.multiFields_default_values || {};
              const fixedRowFiledsCheck = detailField?.type==='multi_field' && detailField?.fixed_Rows && detailField?.repeat_field;
              const multiFieldsdata = Object.values(dafultValues);
              if (detailField.type === 'boolean') {
                temp[detailField.id] = false;
              }
              if (detailField.type !== 'header' && !fixedRowFiledsCheck) {
                requiredMap = {
                  ...requiredMap,
                  [detailField.id]: detailField.type === 'ssi_field' ?false:detailField.required
                };
                if (!detailField.conditional) {
                  fieldErrors = {
                    ...fieldErrors,
                    [detailField.id]: detailField.type === 'ssi_field' ?false:detailField.required
                  };
                } else {
                    if ((detailField?.conditional && detailField.conditional_field?.type === 'boolean'
                      && detailField.conditional_values?.some(i => i.value === 'false')
                    )) {
                      fieldErrors = {
                      ...fieldErrors,
                        [detailField.id]: detailField.required
                    };
                  }
                  conditionalFields[detailField?.conditional_field?.key] = detailField;
                }
              }
              if (fixedRowFiledsCheck && multiFieldsdata) {
                temp[detailField?.id] = multiFieldsdata;
                errorListMCG = handleMultiFieldErrorList(detailField, multiFieldsdata, detailField.id, { errorListMCG });
                let error = false;
                const multiFieldsErrors = {};
                if (detailField?.required && detailField?.multiple_fields) {
                  const multipleFieldsKeys = Object.keys(detailField?.multiple_fields);
                  Object.keys(dafultValues).forEach((eachRow) => {
                    error = multipleFieldsKeys.some(eachSubField => !(multipleFieldsKeys.includes(eachSubField)
                            && (dafultValues?.[eachRow]?.[eachSubField] && `${dafultValues?.[eachRow]?.[eachSubField]}`.length>0)));
                    multiFieldsErrors[eachRow] = error;
                  });
                }
                error = multiFieldsErrors && Object.keys(multiFieldsErrors).some(
                  k => multiFieldsErrors?.[k] === true
                );
                fieldErrors = {
                  ...fieldErrors,
                  [detailField.id]: error
                };
              }
              if (detailField.type === 'attachments') attachmentFields.push(detailField.id);
              if (detailField.type === 'signature') signatureFields.push(detailField.id);
              if (detailField?.validators?.length>0 && detailField.validators[0]?.type === 'Regex' && detailField.validators[0]?.value) {
                let randexp = new RandExp(detailField.validators[0]?.value).gen();
                if (detailField.validators[0]?.label==='Email') {
                  randexp= 'name@email.com';
                }
                placeHolders = {
                  ...placeHolders,
                  [detailField.id]: randexp
                };
              }
            });
          }
          localStorage.setItem('timeFormat', data?.time_format === '24' ? 'HH:mm' : 'hh:mm A');
          localStorage.setItem('dateFormat', data?.date_format || 'MM/DD/YYYY');
          this.setState({
            publicFiledValidations: data.public_user||{},
            formParent: data,
            customFields: fields,
            requiredMap,
            errorListMCG,
            fieldErrors,
            answers: temp,
            loadingStatus: false,
            attachmentFields,
            conditionalFields,
            signatureFields,
            placeHolders
          });
        });
    } catch (error) {
      const message = 'There was a problem while retrieving the form';
      this.setState({
        message,
        apiStatus: true,
        loadingStatus: false
      });
      throw new Error(error);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { answers, customFields, stateInit, formParent, fieldErrors, publicFiledValidations, disableFields } = this.state;
    const answer = { ...answers };
    const fieldError = { ...fieldErrors };
    const publicFiledValidation = { ...publicFiledValidations };
    const disableField = { ...disableFields };
    this.queryParams = new URLSearchParams(window.location.search);
    if (this.queryParams && this.queryParams.size !== 0 && customFields && Object.keys(customFields).length !== 0 && stateInit) {
      customFields.map((e) => {
        if ((e.type === 'string') && this.queryParams.get(e.title)
         && this.queryParams.get(e.title).length !== 0) {
          answer[e.id] = this.queryParams.get(e.title);
          fieldError[e.id] = false;
          disableField[e.id] = true;
        }
        if (e.type === 'number' && this.queryParams.get(e.title)
        && this.queryParams.get(e.title).length !== 0) {
          answer[e.id] = Number(this.queryParams.get(e.title));
          fieldError[e.id] = false;
          disableField[e.id] = true;
        }
        if (e.type === 'multiselect' && this.queryParams.get(e.title)
         && this.queryParams.get(e.title).length !== 0) {
          answer[e.id] = e.values.filter(item => this.queryParams.get(e.title).split(',').find(val => val === item.value)).map(a => a.key);
          fieldError[e.id] = false;
          disableField[e.id] = true;
        }
        if (e.type === 'select' && this.queryParams.get(e.title)
        && this.queryParams.get(e.title).length !== 0) {
          answer[e.id] = e.values.filter(item => item.value === this.queryParams.get(e.title))?.[0]?.key;
          fieldError[e.id] = false;
          disableField[e.id] = true;
        }
        if (e.type === 'boolean' && this.queryParams.get(e.title) && this.queryParams.get(e.title).length !== 0) {
          if (this.queryParams.get(e.title) === 'true') {
            answer[e.id] = true;
            fieldError[e.id] = false;
            disableField[e.id] = true;
          } else if (this.queryParams.get(e.title) === 'false') {
            answer[e.id] = false;
          }
        }
        if (e.type === 'multi_level' && this.queryParams.get(e.title) && this.queryParams.get(e.title).length !== 0) {
          const multiLevelParamsData = this.queryParams.get(e.title).split(',');
          const level0 = multiLevelParamsData[0]?.length !== 0
            ? Object.values(e.values).filter(item => item.title === multiLevelParamsData[0])?.[0] : {};
          const level1 = (level0 !== undefined && level0 !== null)
            && level0.level_1 && multiLevelParamsData[1]?.length !== 0
            ? Object.values(level0.level_1).filter(item => item.title === multiLevelParamsData[1])?.[0] : {};
          const level2 = (level1 !== undefined && level1 !== null)
            && level1.level_2 && multiLevelParamsData[2]?.length !== 0
            ? Object.values(level1.level_2).filter(item => item.title === multiLevelParamsData[2])?.[0] : {};
          answer[e.id] = {
            level_0: (level0 !== undefined && level0 !== null) ? level0.title : '',
            level_1: (level1 !== undefined && level1 !== null) ? level1.title : '',
            level_2: (level2 !== undefined && level2 !== null) ? level2.title : ''
          };
          if (answer[e.id].level_0 && answer[e.id].level_0.length !== 0 && level0 && !level0.level_1) {
            fieldError[e.id] = false;
            disableField[e.id] = true;
          } else if (answer[e.id].level_1 && answer[e.id].level_1.length !== 0 && level1 && !level1.level_2) {
            fieldError[e.id] = false;
            disableField[e.id] = true;
          } else if (answer[e.id].level_2 && answer[e.id].level_2.length !== 0
           && Object.keys(level2).length !== 0) {
            fieldError[e.id] = false;
            disableField[e.id] = true;
          }
        }
        if (e.type === 'dataSourceMultiLevel' && this.queryParams.get(e.title) && this.queryParams.get(e.title).length !== 0) {
          const globalLocationsParams = this.queryParams.get(e.title).split(',');
          const level0 = globalLocationsParams[0]?.length !== 0
            ? Object.values(formParent?.locations)?.filter(item => item.name === globalLocationsParams[0])?.[0] : {};
          const level1 = (level0 !== undefined && level0 !== null)
            && level0.location_levels && globalLocationsParams[1]?.length !== 0
            ? Object.values(level0.location_levels).filter(item => item.title === globalLocationsParams[1])?.[0] : {};
          const level2 = (level1 !== undefined && level1 !== null)
            && level1.level_1 && globalLocationsParams[2]?.length !== 0
            ? Object.values(level1.level_1).filter(item => item.title === globalLocationsParams[2])?.[0] : {};
          const level3 = (level2 !== undefined && level2 !== null)
            && level2.level_2 && globalLocationsParams[3]?.length !== 0
            ? Object.values(level2.level_2).filter(item => item.title === globalLocationsParams[3])?.[0] : {};
          answer[e.id] = {
            level_0: (level0 !== undefined && level0 !== null) ? level0.name : '',
            level_1: (level1 !== undefined && level1 !== null) ? level1.title : '',
            level_2: (level2 !== undefined && level2 !== null) ? level2.title : '',
            level_3: (level3 !== undefined && level3 !== null) ? level3.title : ''
          };
          if (answer[e.id].level_0 && answer[e.id].level_0.length !== 0 && level0 && !level0.location_levels) {
            fieldError[e.id] = false;
            disableField[e.id] = true;
          } else if (answer[e.id].level_1 && answer[e.id].level_1.length !== 0 && level1 && !level1.level_1) {
            fieldError[e.id] = false;
            disableField[e.id] = true;
          } else if (answer[e.id].level_2 && answer[e.id].level_2.length !== 0 && level2 && !level2.level_2) {
            fieldError[e.id] = false;
            disableField[e.id] = true;
          } else if (answer[e.id].level_3 && answer[e.id].level_3.length !== 0 && Object.keys(level3).length !== 0) {
            fieldError[e.id] = false;
            disableField[e.id] = true;
          }
        }
        return answer;
      });
      if (formParent && !formParent.public_user?.none) {
        if (formParent.public_user.name && this.queryParams.get('Name') && this.queryParams.get('Name').length !== 0) {
          answer.name = this.queryParams.get('Name');
          fieldError.name = false;
          publicFiledValidation.name = false;
          disableField.name = true;
        }
        if (formParent.public_user.email && this.queryParams.get('Email') && this.queryParams.get('Email').length !== 0) {
          answer.email = this.queryParams.get('Email');
          fieldError.email = false;
          publicFiledValidation.email = false;
          disableField.email = true;
        }
        if (formParent.public_user.phone && this.queryParams.get('Phone') && this.queryParams.get('Phone').length !== 0) {
          answer.phone = this.queryParams.get('Phone');
          fieldError.phone = false;
          publicFiledValidation.phone = false;
          disableField.phone = true;
        }
      }
      this.updatedParams(answer, fieldError, publicFiledValidation, disableField);
    }
    if (prevState?.answers !== answers) {
    runCumulativeCalculation({
      answers,
      fields: formParent?.form?.schema?.fields || [],
      prevAnswers: prevState?.answers,
      prevFields: formParent?.form?.schema?.fields || [],
      handleAnswerChanged: this.handleAnswerChanged,
      getFieldCalculation, // assume this is in scope or passed as a prop,
      isPublicFormAnswer: true
    });
    }
  }

  updatedParams = (data, customFieldError, defaultFieldValidation, disableField) => {
    const { history } = this.props;
    this.setState({
      answers: {
        ...data
      },
      fieldErrors: {
        ...customFieldError
      },
      publicFiledValidations: {
        ...defaultFieldValidation
      },
      disableFields: {
        ...disableField
      },
      stateInit: false
    });
    history.push(window.location.pathname);
  }

  copyFieldData = (fields, fieldId, answer, answers, currentField) => {
    fields.forEach((field) => {
      const conditional = fieldId === field?.settings?.conditionalCopyField && currentField?.type === 'select'
      ? field?.settings?.conditionalCopyValues?.some(i => i?.value === answer) : answer === true;
      const withoutCondition = !field?.settings?.conditionalCopyField || field?.settings?.conditionalCopyField === '';
      if (conditional || withoutCondition) {
        const ans = (conditional && answers[field?.settings?.selectedCopyField]) || (withoutCondition && answer);
        this.handleFieldErrorChanged(field.id, !ans);
        this.setState(prevState => ({
            answers: {
              ...prevState.answers,
              [field.id]: ans || ''
            }
          }));
        }
      });
  };

  resolveConcatValue = (field, answers, orderedFields) => {
  if (
    !field?.settings?.concatFields
    || !Array.isArray(field?.settings?.selectedContextualField)
    || !Array.isArray(orderedFields)
  ) {
    return null;
  }

  const selectedMap = {};
  field.settings.selectedContextualField.forEach((sf) => {
    selectedMap[sf.value] = sf;
  });

  const result = [];

  orderedFields.forEach((stateField) => {
    const selected = selectedMap[stateField.id];
    if (!selected) return;

    const val = answers?.[stateField.id];
    let output = '';

    if (val !== undefined && val !== null) {
      switch (selected?.type) {
        case 'address':
          output = typeof val === 'object'
            ? Object.values(val).filter(Boolean).join(' ')
            : String(val)
              .replace(/[^a-zA-Z0-9\s]/g, '')
              .replace(/\s+/g, ' ')
              .trim();
          break;

        case 'date':
        case 'datetime':
          output = new Date(val).toLocaleDateString();
          break;

        default:
          output = String(val);
      }
    }
    result.push(output);
  });

  return result.join(' ').replace(/\s+/g, ' ').trim();
};

  handleAnswerChanged = (answer, fieldId, type, section) => {
    const { conditionalFields, publicFiledValidations, customFields, placeHolders, answers } = this.state;
    const copyField = customFields.filter(i => i?.settings?.copyField
      && (i?.settings?.selectedCopyField === fieldId || i?.settings?.conditionalCopyField === fieldId));
      if (copyField?.length > 0) {
        this.copyFieldData(copyField, fieldId, answer, answers, customFields?.find(i => i.id === fieldId));
      }
    if (conditionalFields?.[fieldId] && conditionalFields?.[fieldId].required) {
      const conditionValues = conditionalFields[fieldId]?.conditional_values;
      let fieldValue = answer;
      let enabelCondition = false;
      if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
      if (typeof fieldValue === 'object' && fieldValue?.level_0) {
        enabelCondition = Object.values(fieldValue)?.filter(value => value !== '')?.join()
        === Object.values(conditionValues[0])?.filter(value => value !== '')?.join();
      } else {
      enabelCondition = conditionValues.some(value => fieldValue?.includes(value?.value));
      }
      this.handleFieldErrorChanged(conditionalFields[fieldId].id, enabelCondition);
      this.setState(prevState => ({
        answers: {
          ...prevState.answers,
          [fieldId]: answer,
          [conditionalFields[fieldId].id]: ''
        }
      }));
    } else if (fieldId==='global_location') {
      this.setState(prev => ({
        answers: {
          ...prev?.answers,
          [section]: { ...prev?.answers[section], ...answer }
        }
      }));
    } else if (fieldId ==='location_attachment'|| fieldId ==='location_marked' || fieldId === 'selected_map') {
      this.setState(prev => ({
        answers: {
          ...prev?.answers,
          [section]: { ...prev?.answers[section], [fieldId]: answer }
        }
      }));
    } else if (fieldId ==='location') {
      this.setState(prev => ({
        answers: {
          ...prev?.answers,
          [section]: { ...prev?.answers[section], map_location: answer }
        }
      }));
    } else {
      if (type==='default'&&Object.keys(publicFiledValidations).indexOf(fieldId)>=0) {
        let errVal= false;
        if ((answer.trim()==='')) {
          errVal= true;
        }
        this.setState({
          publicFiledValidations: {
            ...publicFiledValidations,
            [fieldId]: errVal
          }
        });
      }
      const fieldType = customFields?.find(obj => obj.id === fieldId);
      if (fieldType?.type === 'string' && fieldType.validators?.length>0 && fieldType.validators[0]?.value) {
        if (fieldType.validators[0]?.type === 'Regex') {
          let convertValidtorValueToRegex = fieldType.validators[0].value;
          if (fieldType.validators[0]?.label === 'Custom Validation') {
            if (convertValidtorValueToRegex.endsWith('-')) {
              convertValidtorValueToRegex = fieldType.validators[0].value.slice(0, -1);
            }
            convertValidtorValueToRegex = `^${convertValidtorValueToRegex}$`;
          }

          let phoneValConvert = '';
          if (fieldType.validators[0]?.label === 'Phone Number') {
            ({ phoneValConvert, convertValidtorValueToRegex } = getPhoneConvert(answer));
          }

          const regexValue = new RegExp(convertValidtorValueToRegex);
           const validateRegex = (val) => {
            if (fieldType.validators[0]?.multiple_email && answer?.length) {
              const check = answer.split(',').every(eachans => regexValue.test(eachans.trim()));
              return !check;
            }
            return !regexValue.test(val);
          };
          if (answer && validateRegex(phoneValConvert || answer)) {
            this.setState((prevState) => {
              const fieldError = getFieldError(fieldType.validators[0]?.label, fieldId, placeHolders);
              return { errorsList: {
                ...prevState.errorsList,
                [fieldId]: fieldError
              } };
            });
          } else {
            this.setState(prevState => ({ errorsList: {
              ...prevState.errorsList,
              [fieldId]: ''
            } }));
          }
        } else if (fieldType.validators?.length>0 && fieldType.validators[0]?.type === 'maxLength') {
          if (fieldType.validators[0]?.value < answer.length) {
            const fieldError = `Character limit exceeded. Max ${fieldType.validators[0]?.value} characters.`;
            this.setState(prevState => ({ errorsList: {
              ...prevState.errorsList,
              [fieldId]: fieldError
            } }));
          } else {
            this.setState(prevState => ({ errorsList: {
              ...prevState.errorsList,
              [fieldId]: ''
            } }));
          }
        }
      }
      if (fieldType?.type === 'multi_field' && answer?.length > 0) {
        this.setState((prevState) => {
          const updatedErrorListMCG=handleMultiFieldErrorList(fieldType, answer, fieldId, prevState);
          return { errorListMCG: updatedErrorListMCG };
        });
      }
      this.setState(
          (prevState) => {
            const updatedAnswers = {
              ...prevState.answers,
              [fieldId]: answer
            };
            const concatFields = customFields.filter(f => f?.settings?.concatFields);
            concatFields.forEach((concatField) => {
              const concatValue = this.resolveConcatValue(concatField, updatedAnswers,
                customFields);
              if (concatValue !== null) {
                updatedAnswers[concatField.id] = concatValue;
                this.handleFieldErrorChanged(concatField.id, false);
              } else {
                this.handleFieldErrorChanged(concatField.id, true);
              }
            });

            return {
              answers: updatedAnswers,
              customMessage: ''
            };
          }
        );
    }
  }

  handleFieldErrorChanged = (fieldId, errorValue) => {
    // Updates field error map with value passed from field component
    this.setState(prevState => ({
      ...prevState,
      fieldErrors: {
        ...prevState.fieldErrors,
        [fieldId]: errorValue
      }
    }));
  }

  checkConditionalValue = (field) => {
    const { answers } = this.state;

    let isValue = false;
    if (typeof answers[field?.conditional_field?.key] === 'string') {
      isValue = field?.conditional_values.filter(
        value => answers[field?.conditional_field?.key] === value.value
      ).length > 0;
    } else if (typeof answers[field?.conditional_field?.key] === 'object') {
      if (Array.isArray(answers[field?.conditional_field?.key])) {
        isValue = field?.conditional_values.some(
            value => answers[field?.conditional_field?.key]?.indexOf(value.value) !== -1
        );
    } else if (answers[field?.conditional_field?.key]?.level_0) {
      isValue = Object.values(answers[field?.conditional_field?.key])
        ?.filter(value => value !== '')?.join() === Object.values(field.conditional_values[0])
        ?.filter(value => value !== '')?.join();
    }
   } else if (typeof answers[field?.conditional_field?.key] === 'boolean') {
      isValue = field?.conditional_values.filter(
        value => (
          answers[field?.conditional_field?.key].toString() === value?.value
        )
      ).length > 0;
    }

    return isValue;
  }

  handleUploadAttachments = async (attachments, entity) => {
    const {
      formParent
    } = this.state;
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id && e.name) {
        oldAttachments.push(e.name);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await this.getFileNames(newAttachments?.length, formParent.airport_data && formParent.airport_data.airport_code);
    }
    if (fileIds) {
      await this.doS3Upload(
        newAttachments,
        fileIds,
        entity || 'forms'
      ).then(() => {
        fileIds.filename.forEach((id) => {
          attachmentIds.push(id.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }
    return attachmentIds;
  }

  handleMultiColumnGLS = (fieldId, field, ans_values) => {
    const { dataSourceValues } = this.props;
    const specificFieldValues = dataSourceValues[fieldId];
    let finalError;
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(ans_values)) {
      if (key === 'level_0') {
        let levelZeroValues = specificFieldValues?.filter(
          levelZeroValue => (levelZeroValue?.name === value)
        );
        if (levelZeroValues?.length === 0) {
          finalError = field?.mandatory_multi_field || false;
        } else if (value !== '' && levelZeroValues?.length > 0) {
          let levelOneValues = levelZeroValues[0].location_levels;
          if (levelOneValues?.length === 0) {
            finalError = false;
          } else {
            finalError = field?.mandatory_multi_field || false;
          }
        }
      } else if (key === 'level_1') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && levelOneValues?.length > 0) {
          levelOneValues = levelOneValues.filter(
            val => val?.title === value
          );
          if (levelOneValues.length === 0) {
            finalError = field?.mandatory_multi_field || false;
          } else if (value !== '' && levelOneValues?.length > 0) {
            levelTwoValues = levelOneValues[0].level_1;
            if (levelTwoValues?.length === 0) {
              finalError = false;
            } else {
              finalError = field?.mandatory_multi_field || false;
            }
          }
        }
      } else if (key === 'level_2') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        let levelThreeValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && ans_values?.level_1 && levelOneValues?.length > 0) {
          levelTwoValues = levelOneValues.filter(
            val => (val?.title === ans_values?.level_1)
          );
          if (levelTwoValues.length === 0) {
            finalError = field?.mandatory_multi_field || false;
          } else if (value !== '' && levelThreeValues?.length > 0) {
            levelThreeValues = levelTwoValues[0].level_1;
            if (levelThreeValues?.length === 0) {
              finalError = false;
            } else {
              finalError = field?.mandatory_multi_field || false;
            }
          }
        }
      } else if (key === 'level_3') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        let levelThreeValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && ans_values?.level_1 && ans_values?.level_2 && levelOneValues?.length > 0) {
          levelTwoValues = levelOneValues.filter(
            val => (val?.title === ans_values?.level_1)
          );
          levelTwoValues = levelTwoValues[0].level_1;
          levelTwoValues = levelTwoValues.filter(
            val => (val?.title === ans_values?.level_2)
          );
          levelThreeValues = levelTwoValues[0].level_2;
          if (levelThreeValues.length === 0) {
            finalError = false;
          } else if (value !== '' && levelThreeValues?.length > 0) {
            finalError = false;
          }
        }
      }
    }
    return finalError;
  }

  handleMultiFieldIndividualError = () => {
    const {
      answers: {
        form_date,
        created_by,
        source,
        name,
        email,
        phone,
        ...form_data
      },
      customFields
    } = this.state;
    let finalErrorData = [];
    customFields.forEach((field) => {
      if (field.type === 'multi_field' && field.multiple_fields && !field.repeat_field) {
        const formValues = form_data[field.id]?.[0] || {};
        if (!formValues) return;
        finalErrorData = [...finalErrorData, ...handleMultiGridSpecificFieldError(field, formValues, this.handleMultiColumnGLS, form_data)];
      } else if (field.type === 'multi_field' && field.multiple_fields && field.repeat_field) {
        const formValues = form_data[field.id];
        if (!formValues) {
          finalErrorData = [...finalErrorData, ...handleMultiGridSpecificFieldError(field, {}, this.handleMultiColumnGLS, form_data)];
        } else {
          formValues.forEach((formValue) => {
            finalErrorData = [...finalErrorData, ...handleMultiGridSpecificFieldError(field, formValue, this.handleMultiColumnGLS, form_data)];
          });
        }
      }
    });
    return finalErrorData;
  }

  handleSubmit = async () => {
    const {
      fieldErrors, publicFiledValidations,
      answers: { email, name, phone, ...form_data },
      signatureFields, formParent, customFields, errorsList, errorListMCG
    } = this.state;
    const { match: { params: { formKey } } } = this.props;
    if (publicFiledValidations.none) delete publicFiledValidations.none;

    if (customFields?.length> 0) {
      customFields.forEach((field) => {
      if (field.type === 'toggle' && Object.prototype.hasOwnProperty.call(fieldErrors, field.id)) {
       fieldErrors[field.id]=false;
     }
     });
   }
   let multiFieldError = this.handleMultiFieldIndividualError();
    if (multiFieldError.length === 0) {
      customFields.forEach((field) => {
        if (field.type === 'multi_field') {
            fieldErrors[field.id] = false;
        }
      });
    } else {
      customFields.forEach((field) => {
        if (field.type === 'multi_field') {
            fieldErrors[field.id] = true;
        }
      });
    }
    const noErrors = Object.keys(fieldErrors)
      .every(k => (fieldErrors[k] === false));
    const puberr = Object.keys(publicFiledValidations)
      .every(k => (publicFiledValidations[k] === false));
    const attachmentFields = formParent?.form?.schema?.fields.filter(schemaField => (
      schemaField?.type === 'attachments' || schemaField?.type === 'multi_field'
    ));
    const defaultFormSubmitFields = formParent?.form?.schema?.fields.filter(field => (
      (['date', 'datetime', 'dateWithSeconds', 'datetimeWithSeconds'].includes(field.type))
      && field?.default_form_submit_date
    ));

    const dateFields = formParent?.form?.schema?.fields?.filter(item => (
      ['date', 'datetime', 'dateWithSeconds', 'datetimeWithSeconds'].includes(item?.type)
    ));
    if (dateFields?.length > 0) {
      for (let index = 0; index < dateFields.length; index++) {
        const dateField = dateFields[index]?.id;
        const schemaField = dateFields[index];
        if (form_data[dateField] !== undefined && form_data[dateField] !== null && form_data[dateField] !== '') {
          form_data[dateField] = normalizeSubmittedDateValue(schemaField, form_data[dateField]);
        }
      }
    }

    const errorsListValues = Object.values(errorsList).filter(val => val!=='');
    let customError = false;
    let customMessage = '';
    let customValidation = formParent?.custom_validation;
    try {
      if (customValidation) {
        /* eslint-disable no-unused-vars */
        const fd = form_data;
        const dt = f => (typeof (f) === 'object' ? new Date(f.toISOString()) : new Date(f));
        // eslint-disable-next-line no-eval
        eval(customValidation);
      }
    } catch (error) {
      // nothing
    }

    const errorMCGlist = Object.keys(errorListMCG).map(val => ({ [val]: errorListMCG[val] }));

    if (noErrors && !customError && puberr && errorsListValues.length === 0 && errorMCGlist.length === 0) {
      this.setState({ loadingStatus: true });
      let number = phone;
      if (number) number = number[0] + number.slice(1).replace(/[^\d]/g, '');
      if (defaultFormSubmitFields.length > 0) {
        for (let index = 0; index < defaultFormSubmitFields.length; index++) {
          const dateField = defaultFormSubmitFields[index]?.id;
          form_data[dateField] = moment().format();
        }
      }
      if (attachmentFields.length > 0) {
        for (let index=0; index < attachmentFields.length; index++) {
          const attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          if (schemaField?.type === 'attachments' && form_data[attachmentField]?.length > 0) {
            form_data[attachmentField] = await this.handleUploadAttachments(form_data[attachmentField], 'forms');
          } else if (schemaField?.type === 'multi_field') {
            const multiAttachmentFields = schemaField?.multiple_fields
              && Object.keys(schemaField?.multiple_fields)?.filter(f => schemaField?.multiple_fields?.[f]?.type?.key === 'attachments');
            if (multiAttachmentFields?.length > 0) {
              for (let multiIndex = 0; multiIndex < multiAttachmentFields.length; multiIndex++) {
                for (let multiDataIndex = 0; multiDataIndex < form_data?.[schemaField?.id].length; multiDataIndex++) {
                  const attachments = form_data?.[schemaField?.id]?.[multiDataIndex]?.[multiAttachmentFields[multiIndex]] || [];
                  if (attachments?.length > 0) {
                    form_data[schemaField?.id][multiDataIndex][multiAttachmentFields[multiIndex]] = attachments?.map(attach => (
                      attach?.attachmentUploadId || attach?.name
                    ));
                  }
                }
              }
            }
          }
        }
      }
      if (signatureFields.length > 0) {
        for (let i = 0; i < signatureFields.length; i++) {
          const signatureField = signatureFields[i];
          if (form_data[signatureField]) {
            form_data[signatureField] = await this.handleUploadAttachments([form_data[signatureField]], 'forms');
          }
        }
      }

      customFields.forEach((val) => {
        const phoneType = val?.type === 'string' && val?.validators?.length>0 && val?.validators[0]?.label === 'Phone Number' && val;
        if (phoneType && form_data[phoneType.id]) form_data[phoneType.id] = form_data[phoneType.id][0] + form_data[phoneType.id].slice(1).replace(/[^\d]/g, '');
      });
      const data = {
        form_date: new Date(),
        email,
        name,
        phone: number,
        data: form_data,
        has_map_location: getHasMapLocation(customFields, form_data)
      };
      customFields.forEach((field) => {
        if (field.type === 'toggle' && !Object.prototype.hasOwnProperty.call(data.data, field.id)) {
            data.data[field.id]=false;
        }
      });
      try {
        await fetch(`${this.publicUrl}/forms/create_answer/${formKey}`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: { 'Content-Type': 'application/json' }
        })
          .then(response => response.json())
          .then((res) => {
            if (res.errors) {
              this.setState({
                message: 'There was a problem while submitting the form',
                apiStatus: true,
                loadingStatus: false
              });
            } else {
              const shortYear = new Date().getFullYear().toString().slice(-2);
              this.setState({
                message: 'Your form entry has been submitted successfully.',
                apiStatus: true,
                loadingStatus: false,
                form_submission_success_msg: `Your ${formParent && formParent.title}
                  (${res?.auto_gen ?? `# ${shortYear} - ${res.order_numer}`}) submitted successfully.`,
                trackingId: res?.auto_gen ?? res.order_numer
              });
            }
          });
      } catch (error) {
        let message = 'There was a problem while submitting the form';
        if (error && error.detail) message = error.detail;
        this.setState({
          message,
          apiStatus: true,
          loadingStatus: false
        });
      }
    } else {
      this.setState({ showFormErrors: true, customMessage });
    }
  }

  handleSign = (fieldId) => {
    if (this.sigCanvas[fieldId].getTrimmedCanvas().toDataURL('image/png')) {
      const signatureFile = this.dataURLtoFile(this.sigCanvas[fieldId].getTrimmedCanvas().toDataURL('image/png'), `${fieldId}.png`);
      this.handleAnswerChanged(signatureFile, fieldId);
      this.handleFieldErrorChanged(fieldId, false);
    }
  }

  signClear = (fieldId, isRequired) => {
    this.sigCanvas[fieldId].clear();
    this.handleAnswerChanged('', fieldId);
    if (isRequired) {
      this.handleFieldErrorChanged(fieldId, true);
    } else {
      this.handleFieldErrorChanged(fieldId, false);
    }
  }

  dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  getFileNames = async (count, airportCode) => {
    const response = await GetFileName.getPublicUploadFileName(count, airportCode);
    return response;
  };

  doS3Upload = async (files, fileIds, entity) => {
    const { match } = this.props;
    const { formParent } = this.state;
    const installation = match.params.id;
    const airportCode = formParent.airport_data.airport_code;
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      installation,
      airportCode
    );
    return response;
  };

  checkAllChecklistsSelected =(fieldId) => {
    const { answers, formTabFeilds } = this.state;
    const isRequired = formTabFeilds?.filter(each => each.id===fieldId)?.[0]?.required || false;
    let flag = false;
    if (isRequired && answers[fieldId]) {
      const answered = Object.keys(answers[fieldId]);
      let questions = formTabFeilds?.filter(each => each.id===fieldId)?.[0]?.schema?.fields || [];
      questions = questions?.filter(each => each.type==='inspection');
      if (answered.length === questions.length) {
        flag=answered.every((each) => {
          const qtnsChecklists = questions.filter(e => e.id=== each)?.[0]?.checklist?.length;
          if (Object.keys(answers[fieldId][each]).length === qtnsChecklists) {
            return true;
          }
          return false;
        });
      }
    }
    if (flag || !isRequired) {
      this.handleFieldErrorChanged(fieldId, false);
    }
  }

  handleCheckListAnswer = (fieldId, checkLisId, subCheckListKey, pass, remarks) => {
    const { answers } = this.state;
    let useCheckObj = {
      [fieldId]: {
        ...answers?.[fieldId],
        [checkLisId]: {
          ...answers?.[fieldId]?.[checkLisId],
          [subCheckListKey]: {
            ...answers?.[fieldId]?.[checkLisId]?.[subCheckListKey],
            check_lilst_status: pass,
            checklist_remarks_list: remarks
          }
        }
      }
    };
    this.setState(prevState => ({
      answers: {
        ...prevState.answers,
        ...useCheckObj
      }
    }), () => this.checkAllChecklistsSelected(fieldId));
  }

  handleSearchFormStatus = (value) => {
    this.setState({ searchStatusQuery: value });
  }

  getShowFieldErrors = (isReqMap, showFormErrors, field) => {
    const { errorsList } = this.state;
    if (isReqMap) {
        if (showFormErrors) {
        return true;
      } if (errorsList?.[field.id]?.length>0) {
        return true;
      }
    }
    return false;
  }

  handleSearchQuery = async () => {
    const { searchStatusQuery, formParent } = this.state;
    let searchObj = {};
    if (formParent?.auto_gen) {
      searchObj = {
        auto_gen: searchStatusQuery.trim()
      };
    } else {
      searchObj = {
        order_number: searchStatusQuery.trim()
      };
    }
    this.setState({
      loadingStatus: true
    });
    try {
      await fetch(`${this.publicUrl}/forms/public_form_status/${this.props?.match?.params?.formKey}/${formParent?.airport_data?.airport_code}/
?${searchObj?.auto_gen ? `auto_gen=${searchObj?.auto_gen}` : `order_number=${searchObj?.order_number}`}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(response => response.json())
        .then((res) => {
          if (res.errors) {
            this.setState({
              formStatusMessage: `No data found with above reference number ${searchObj?.auto_gen ?? searchObj?.order_number}`,
              loadingStatus: false
            });
          } else {
            this.setState({
              publicFormData: res?.form_answer_details,
              formStatusMessage: !res?.form_answer_details?.id
                ? `No data found with above reference number ${searchObj?.auto_gen ?? searchObj?.order_number}`
                : '',
              loadingStatus: false
            });
          }
        });
    } catch (error) {
      let message = 'There was a problem while fetching the form data';
      if (error && error.detail) message = error.detail;
    }
  }

  // OVERRIDE FIELD TYPE IF NEED
  handleGetFieldType = (typeInfo) => {
    let fieldHasType = typeInfo.type;
    if (typeInfo?.type === 'string' && typeInfo?.validators?.length > 0 && typeInfo?.validators?.[0]?.label === 'Phone Number') {
      fieldHasType = 'telephone';
    } else if (['dateWithSeconds', 'datetimeWithSeconds', 'only_time_with_seconds'].includes(typeInfo?.type)) {
      fieldHasType = typeInfo?.type?.includes('time') ? 'time' : 'datetime';
    } else if (typeInfo?.type === 'date' && (typeInfo?.settings?.dateWithSeconds || typeInfo?.dateWithSeconds)) {
      fieldHasType = 'datetime';
    } else if (typeInfo?.type === 'number' && typeInfo?.validators?.length > 0 && typeInfo?.validators?.[0]?.type === 'currencyInput') {
      fieldHasType = 'currency-phone';
    }
    return fieldHasType;
  }

  // SET OTHER PROPS TO PULPOFILED IF NEED
  getOtherFieldInfo = (typeInfo) => {
    const { formParent } = this.state;
    let otherFieldInfo = {};
    if (typeInfo?.type === 'number' && typeInfo?.validators?.length > 0 && typeInfo?.validators?.[0]?.type === 'currencyInput') {
      otherFieldInfo = {
        prefix: formParent.airport_data?.currency || '$',
        thousandSeparator: true,
        placeHolderValue: formParent.airport_data?.currency || '$',
        decimalDigits: 2
      };
    }
    otherFieldInfo = {
      ...otherFieldInfo,
      sendWithSecond: getFieldUsesSeconds(typeInfo)
    };
    return otherFieldInfo;
  }

  handleMultiLocation = (corr, type, shape, fieldId, allowMultiple = false) => {
    const { answers } = this.state;
    let longlat = answers[fieldId] || {};
    if (allowMultiple) {
      longlat[type] = corr;
    } else if (shape === 'Point') {
      longlat[type] = { type: 'Point', coordinates: corr };
    } else if (shape === 'Polygon') {
      longlat[type] = { type: 'Polygon', coordinates: [corr] };
    } else if (shape === 'Polyline') {
      longlat[type] = { type: 'LineString', coordinates: corr };
    }
    this.handleAnswerChanged(longlat, fieldId);
    this.handleFieldErrorChanged(fieldId, false);
  }

  handleRemoveChanged = (corr, type, shape, fieldId, allowMultiple = false) => {
    const { answers } = this.state;
    if (allowMultiple) {
      const formatCoord = ([lng, lat]) => `${lng},${lat}`;
      let longlat = answers[fieldId] || {};
      if (shape === 'Point') {
        longlat = {
          ...longlat,
          locations: longlat?.locations?.filter(loc => loc.coordinates[0] !== corr[0] && loc.coordinates[1] !== corr[1])
        };
      } else if (shape === 'Polygon') {
        let valueSet = new Set(corr.map(formatCoord));
        longlat = {
          ...longlat,
          polygons: longlat?.polygons?.filter(polygon => polygon.coordinates[0].every(coords => !valueSet.has(formatCoord(coords))))
        };
      } else if (shape === 'Polyline') {
        let valueSet = new Set(corr.map(formatCoord));
        longlat = {
          ...longlat,
          polylines: longlat?.polylines?.filter(polyline => polyline.coordinates.every(coords => !valueSet.has(formatCoord(coords))))
        };
      }
      const checkData = Object.values(longlat).every(
        value => value === undefined || (Array.isArray(value) && value.length === 0)
      );
      if (checkData) {
        this.handleFieldErrorChanged(fieldId, true);
        this.handleAnswerChanged('', fieldId);
      } else {
        this.handleFieldErrorChanged(fieldId, false);
        this.handleAnswerChanged(longlat, fieldId);
      }
    } else {
      let longlat = answers[fieldId] || {};
      delete longlat[type];

      if (Object.keys(longlat)?.length === 0) {
        this.handleFieldErrorChanged(fieldId, true);
        this.handleAnswerChanged('', fieldId);
      } else {
        this.handleFieldErrorChanged(fieldId, false);
        this.handleAnswerChanged(longlat, fieldId);
      }
    }
  };

  handleEditChanged = (corr, prevcorr, type, shape, fieldId, allowMultiple = false) => {
    const { answers } = this.state;
    if (allowMultiple) {
      let longlat = answers[fieldId] || {};
      let existingShape = longlat[type] || [];

      if (shape === 'Point') {
        let indexToUpdate = existingShape.findIndex(obj => obj.coordinates[0] === prevcorr[0] && obj.coordinates[1] === prevcorr[1]);
        if (indexToUpdate !== -1) {
          existingShape[indexToUpdate].coordinates = corr;
        }
      } else if (shape === 'Polygon') {
        existingShape = prevcorr.map((c) => {
          if (c?.coordinates?.length > 0) {
            let cor = c?.coordinates;
            const first = cor[0];
            const last = cor[cor.length - 1];
            if (first[0] !== last[0] || first[1] !== last[1]) {
              cor.push([...first]);
            }
            return {
              type: 'Polygon',
              coordinates: [cor]
            };
          }
          return null;
        });
      } else if (shape === 'Polyline') {
        existingShape = prevcorr.map(c => ({ type: 'LineString', coordinates: c.coordinates }));
      }

      longlat[type] = existingShape;
      this.handleAnswerChanged(longlat, fieldId);
      this.handleFieldErrorChanged(fieldId, false);
    } else {
      let longlat = answers[fieldId] || {};
      if (shape === 'Point') {
        longlat[type] = { type: 'Point', coordinates: corr };
      } else if (shape === 'Polygon') {
        if (prevcorr[0]?.coordinates?.length > 0) {
          let cor = prevcorr[0]?.coordinates;
          const first = cor[0];
          const last = cor[cor.length - 1];
          if (first[0] !== last[0] || first[1] !== last[1]) {
            cor.push([...first]);
          }
          longlat[type] = {
            type: 'Polygon',
            coordinates: [cor]
          };
        }
      } else if (shape === 'Polyline') {
        longlat[type] = {
          type: 'LineString',
          coordinates: prevcorr[0]?.coordinates
        };
      }
      this.handleAnswerChanged(longlat, fieldId);
      this.handleFieldErrorChanged(fieldId, false);
    }
  }

  render() {
    const { answers, showFormErrors, formParent, requiredMap, message,
      apiStatus, loadingStatus, customFields, errorsList, placeHolders, disableFields,
      form_submission_success_msg, customMessage, active_tab, searchStatusQuery, trackingId,
      publicFormData, formStatusMessage, errorListMCG
     } = this.state;

     const sectionHeaders = customFields?.filter(field => field.type === 'header');
     let styleObj = {};
     if (formParent?.form?.settings?.enable_check_public_status_for_workflow_form) {
      styleObj={
        justifyContent: 'start'
      };
     }

    // THIS `portalUsersDropdownValues` is using for portal_user field
    // portal_user IS OPTIONAL FIELD IN PUBLIC FORM
    const portalUsersDropdownValues = [];
    const toolTip = field => (
      <>
        {(field?.rte_description || field?.description) && (
        <TooltipWithHeading
          title="Help"
          toolTip={`form.setting.newfield.helptext.${field.rte_description || field.description}`}
          text={<div dangerouslySetInnerHTML={{ _html: field.rte_description || field.description }} />}
          values={field.rte_description || field.description}
          iconStyles={styles.helpTooltip}
        />
        )}
      </>
    );

    const getCustomFieldComponent = fields => (
      <>
        {fields.map(field => (
            <>
              {!field.conditional && field.hide_for_all_users !==true && (
                <>
                  {field.type === 'header' && (
                    <>
                      {field.collapsible ? (
                        <div className={styles.collapseHeader}>
                          <Collapsible
                            title={field.title} openOnMount
                            styleClasses={styles.header}
                            collapseDesc
                          >
                            {field?.enable_rte ? (
                              <div>
                                <div className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                              </div>
                              ) : (
                              <div className={styles.description}>
                                <p>{field.description}</p>
                              </div>
                            )}
                          </Collapsible>
                        </div>
                      ): (
                        <>
                          <div className={`${styles.header} ${styles.sectionHeader}`}>
                            {field.title}
                            {toolTip(field)}
                          </div>
                          <div>
                            <pre className={styles.description}>
                              {field.description}
                            </pre>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {field.type === 'map_location' && field?.shape !== 'All'
                    && !field?.settings?.allow_multiple_location && (
                  <PulpoField key={field.id} {...field} airportInfo={formParent.airport_data}
                    handleValueChange={this.handleAnswerChanged}
                    isRequired={requiredMap[field.id]} answer={answers[field.id]}
                    showFieldErrors={showFormErrors} handleFieldErrorChanged={this.handleFieldErrorChanged}
                    className={styles.fullWidth} addressEnabled={field?.address_location}
                    title={field?.address_location ? 'Address' : field.title}
                    translationID={field?.address_location ? 'custom_field.address.title' : field.title}
                    locationId={field.title}
                    locationTitle={field.title}
                    newPublicForm
                    enableDelete
                  />
                  )}
                  {field.type === 'map_location' && (field?.shape === 'All'
                  || field?.settings?.allow_multiple_location) && (
                    <PulpoField
                      key={field.id}
                      {...field}
                      type="multi_location"
                      enableDelete
                      shape={field?.shape !== 'All' ? field?.shape : undefined}
                      title={field?.title}
                      isRequired={requiredMap[field.id]}
                      handleValueChange={(a, b, type) => this.handleMultiLocation(
                        a, b, type, field?.id, field?.settings?.allow_multiple_location
                      )}
                      handleValueRemove={(a, b, type) => this.handleRemoveChanged(
                        a, b, type, field?.id, field?.settings?.allow_multiple_location
                      )}
                      handleValueEdit={(a, b, type, key) => this.handleEditChanged(
                        a, b, type, key, field?.id, field?.settings?.allow_multiple_location
                      )}
                      answer={answers && answers[field.id]}
                      className={styles.fullWidth}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                      showFieldErrors={showFormErrors}
                      fromForms
                      allowMultiple={field?.settings?.allow_multiple_location}
                      airportInfo={formParent.airport_data}
                    />
                  )}
                 {field.type=== 'select' && field?.settings?.codeValues
                    && (
                  <>
                    <PulpoField
                      key={field.id}
                      id={field.id}
                      type="string"
                      title={field?.settings?.textForCodedValues}
                      disabled
                      handleValueChange={this.handleAnswerChanged}
                      answer={answers && field?.values[answers[field.id]]?.coded_value}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                    />
                  </>)
                  }
                  {field.type === 'annotation' && field?.annotate_attachment?.length > 0 && field?.annotate_attachment[0]?.url &&(
                    <div style={{ width: '100%' }}>
                      {field.required && <small style={{ color: 'red' }}> * </small> }
                      <span className={styles.field_title}>{field.title}</span>
                      <Annotations imgSrc={(answers[field.id]?.length > 0 && answers[field.id][0]?.url)
                        ? answers[field.id][0]?.url : field?.annotate_attachment[0]?.url}
                        existingImgSrc={field?.annotate_attachment[0]?.url} existingPaths={answers[field.id] || []}
                        handleFieldErrorChanged={error => this.handleFieldErrorChanged(field.id, error)}
                        handleSavePath={val => this.handleAnswerChanged(val, field.id)} drawMode />
                      {showFormErrors && field?.required && (
                          <small style={{ color: 'red' }}>
                              {(!answers[field?.id] || (answers[field?.id]?.length === 0)) && (
                                <FormattedMessage id="pulpoforms.errors.not_blank" defaultMessage="This field cannot be empty" />
                              )}
                          </small>)}
                    </div>)}
                    {field?.type === 'toggle'
                    && <PulpoField
                    key={field.id}
                    {...field}
                    translation={field.title}
                    handleValueChange={this.handleAnswerChanged}
                    isRequired={requiredMap[field.id]}
                    answer={field}
                    showFieldErrors={showFormErrors}
                    handleFieldErrorChanged={this.handleFieldErrorChanged}
                    className={styles.fullWidth}
                    type={field?.type}
                    needFlex
                    fromToggle
                      {...this.props}
                  />
                  }
                  {field.type === 'attachments' && (
                    <Attachments
                      {...field}
                      handleAnswerChanged={this.handleAnswerChanged}
                      attachments={answers[field.id]}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                      newForm
                    />
                  )}
                  {field.type === 'inspection_checklist' && (
                    <PulpoField
                      key={field.id}
                      {...field}
                      translation={field.title}
                      handleValueChange={this.handleCheckListAnswer}
                      isRequired={requiredMap[field.id]}
                      answer={answers && answers[field.id]}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                      className={styles.fullWidth}
                      type={field.type}
                        // {...this.props}
                    />
                  )}
    {field?.type === 'dataSourceMultiLevel' && field?.dataSourceID === 'ds2'
    && (
        <MultiLevelLocation
          info={{
        ...answers, global_location: answers?.[field?.id], location: answers?.[field?.id]?.map_loaction || formParent.airport_data.location
          }}
          locationList={formParent?.locations || []}
          onInfoChange={(a, b, c) => this.handleAnswerChanged(b, a, null, c)}
          fieldName={field?.levels}
          withoutDepartments
          locationKey="name"
          withFloorPlan
          fromSMS
          field={field}
          fieldId={field?.id}
          isRequiredTrue={field?.required}
          showFormErrors={showFormErrors}
          handleFieldErrorChanged={(a, b) => this.handleFieldErrorChanged(field?.id, b)}
          singleLocation={false}
          defaultLocation={formParent.airport_data.location}
          location_marked={answers[field?.id]?.location_marked}
          assetRegistry
        />
    )}
                  {field?.type === 'multi_field' && (
                      <MultiColumnGrid
                        currentField={field}
                        handleAnswerChanged={this.handleAnswerChanged}
                        answers={answers}
                        handleUploadAttachments={this.handleUploadAttachments}
                        flexWrap
                        errorListMCG={errorListMCG}
                        showFormErrors={showFormErrors}
                        allFields={customFields}
                        formParent={formParent}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                        from="forms"
                        isPublic
                      />
                  )}
                  { field?.type === 'multi_level'
          && (
          <>
            {/* don't even change the props passing position here,
                  it will raise not displaying or page break issues */}
            <PulpoField
              {...field}
              levels={{
                level_0: {
                  title: `${field?.title}`
                },
                level_1: {
                  title: `${field?.title} 1`
                },
                level_2: {
                  title: `${field?.title} 2`
                }
              }}
              title={field?.title}
              values={typeof field.values === 'object'
                ?Object.values(field.values).map(item => ({ ...item, name: item.title })):[]}
              handleValueChange={this.handleAnswerChanged}
              handleFieldErrorChanged={this.handleFieldErrorChanged}
              isRequired={requiredMap[field.id]}
              showFieldErrors={showFormErrors}
              allFields={customFields}
              forFormModule
              answer={answers && answers[field.id]}
              type="dataSourceMultiLevel"
              disabled={disableFields && disableFields[field.id]}
            />
          </>)
        }
                  {field.type !== 'header'
                  && field.type !== 'page_break'
                  && field?.type !== 'multi_field'
                  && field.type !== 'portal_user'
                  && field.type !== 'attachments'
                  && field.type !== 'duration'
                  && field.type !== 'map_location'
                  && field.type !== 'annotation'
                  && field.type !== 'signature'
                  && field?.type !== 'ssi_field'
                  && field?.type !== 'multi_level'
                  && field?.type !== 'inspection_checklist'
                  && field?.type !== 'toggle'
                  && !(field?.type === 'dataSourceMultiLevel' && field?.dataSourceID === 'ds2')&& (
                    <PulpoField
                      key={field.id}
                      {...field}
                      onlyTime={TIME_FIELD_TYPES.includes(field.type)}
                      translation={field.title}
                      handleValueChange={this.handleAnswerChanged}
                      isRequired={requiredMap[field.id]}
                      answer={answers[field.id]}
                      showFieldErrors={this.getShowFieldErrors(requiredMap[field.id], showFormErrors, field)}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                      className={field.full_width ? styles.fullWidth : ''}
                      customField={field?.type !== 'select'}
                      noDefault={(TIME_FIELD_TYPES.includes(field.type)
                        || DATE_SUBMIT_FIELD_TYPES.includes(field.type)) && !field?.default}
                      allDataSources={formParent?.data_sources}
                      publicForm locations={formParent?.locations}
                      datasources={formParent?.generic_datasource}
                      customError={errorsList && errorsList[field.id]}
                      placeHolder={placeHolders && placeHolders[field.id]}
                      type={`${this.handleGetFieldType(field)}`}
                      {...this.getOtherFieldInfo(field)}
                      disabled={(disableFields && disableFields[field.id]) || (field.type === 'string' && field?.hide_default_text)}
                      Badging={field.type !== 'address'}
                      dateEditable
                      avp={field.type === 'date'}
                      newPublicForm
                      customFields={customFields}
                      answers={answers}
                      allFields={customFields}
                      formEntryFields={customFields}
                    />
                  )}
                  {field?.type === 'duration' && (
                    <PulpoField
                      key={field.id}
                      {...field}
                      translation={`${field?.title} (${field?.duration_fields?.calculationFormat?.name})`}
                      handleValueChange={this.handleAnswerChanged}
                      isRequired={requiredMap[field.id]}
                      answer={answers[field.id]}
                      customError={errorsList && errorsList[field.id]}
                      placeHolder={placeHolders && placeHolders[field.id]}
                      formField
                      fromMeeting
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                      className={field.full_width ? styles.fullWidth : ''}
                      type={field.type}
                      {...this.props}
                      answers={answers}
                      fullWidth={field?.full_width || false}
                    />
                  )}
                  {field.type === 'signature' && (
                    <div className={styles.signature}>
                      {field.required && <small style={{ color: 'red' }}> * </small>}
                      <FormattedMessageWithClass
                        className={styles.label} id={field.title}
                        defaultMessage={field.title}
                      />
                      <div style={answers[field.id] && answers[field.id].length ? { display: 'none' } : { display: 'block' }}>
                        <SignatureCanvas
                          ref={(ref) => { this.sigCanvas[field.id] = ref; }}
                          penColor="black"
                          canvasProps={{ width: 778, height: 152, className: styles.sigCanvas }}
                          onEnd={() => this.handleSign(field.id)}
                        />
                      </div>
                      <Button
                        action="tertiary"
                        onClick={() => this.signClear(field.id)}
                        translationID="filters.form.clear"
                        defaultText="clear"
                        className={styles.button}
                      />
                      {showFormErrors && field.required && (
                      <small style={{ color: 'red' }}>
                        {(!answers[field.id] || (answers[field.id].length === 0)) && (
                        <FormattedMessage id="pulpoforms.errors.not_blank"
                          defaultMessage="This field cannot be empty"
                        />
                        )}
                      </small>
                      )}
                    </div>
                  )}
                  {field.type === 'portal_user' && (
                    <PulpoField
                      key={field.id}
                      {...field}
                      values={portalUsersDropdownValues || []}
                      title={field?.title}
                      handleValueChange={this.handleAnswerChanged}
                      isRequired={requiredMap[field.id]}
                      answer={answers && answers[field.id]}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                      className={field.full_width ? styles.fullWidth: ''}
                      default_value={field?.default_value}
                      type="select"
                      widget={{ type: 'portal_user' }}
                    />
                  )}
                </>
              )}
              {field.conditional
              && (answers[field?.conditional_field?.key] || field?.conditional_field?.type === 'boolean')
              && this.checkConditionalValue(field)
              && field.hide_for_all_users !==true && (
                <>
                  {field.type === 'header' && (
                    <>
                      {field.collapsible ? (
                        <div className={styles.collapseHeader}>
                          <Collapsible
                            title={field.title} openOnMount
                            styleClasses={styles.header}
                          >
                            <div>
                              <pre className={styles.description}>
                                {field.description}
                              </pre>
                            </div>
                          </Collapsible>
                        </div>
                      ): (
                        <>
                          <div className={styles.header}>
                            {field.title}
                          </div>
                          <div>
                            <pre className={styles.description}>
                              {field.description}
                            </pre>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {field.type === 'map_location' && field?.shape !== 'All'
                    && !field?.settings?.allow_multiple_location && (
                  <PulpoField key={field.id} {...field} airportInfo={formParent.airport_data}
                    handleValueChange={this.handleAnswerChanged}
                    isRequired={requiredMap[field.id]} answer={answers[field.id]}
                    showFieldErrors={showFormErrors} handleFieldErrorChanged={this.handleFieldErrorChanged}
                    className={styles.fullWidth} addressEnabled={field?.address_location}
                    title={field?.address_location ? 'Address' : field.title}
                    translationID={field?.address_location ? 'custom_field.address.title' : field.title}
                    locationId={field.title}
                    locationTitle={field.title}
                    enableDelete
                  />
                  )}
                  {field.type === 'map_location' && (field?.shape === 'All'
                  || field?.settings?.allow_multiple_location) && (
                    <PulpoField
                      key={field.id}
                      {...field}
                      type="multi_location"
                      shape={field?.shape !== 'All' ? field?.shape : undefined}
                      title={field?.title}
                      isRequired={requiredMap[field.id]}
                      handleValueChange={(a, b, type) => this.handleMultiLocation(
                        a, b, type, field?.id, field?.settings?.allow_multiple_location
                      )}
                      handleValueRemove={(a, b, type) => this.handleRemoveChanged(
                        a, b, type, field?.id, field?.settings?.allow_multiple_location
                      )}
                      handleValueEdit={(a, b, type, key) => this.handleEditChanged(
                        a, b, type, key, field?.id, field?.settings?.allow_multiple_location
                      )}
                      answer={answers && answers[field.id]}
                      className={styles.fullWidth}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                      showFieldErrors={showFormErrors}
                      fromForms
                      enableDelete
                      allowMultiple={field?.settings?.allow_multiple_location}
                      airportInfo={formParent.airport_data}
                    />
                  )}
                  {field.type === 'inspection_checklist' && (
                    <PulpoField
                      key={field.id}
                      {...field}
                      translation={field.title}
                      handleValueChange={this.handleCheckListAnswer}
                      isRequired={requiredMap[field.id]}
                      answer={answers && answers[field.id]}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                      className={styles.fullWidth}
                      type={field.type}
                        // {...this.props}
                    />
                  )}
                  {field?.type === 'toggle'
                    && <PulpoField
                    key={field.id}
                    {...field}
                    translation={field.title}
                    handleValueChange={this.handleAnswerChanged}
                    isRequired={requiredMap[field.id]}
                    answer={field}
                    showFieldErrors={showFormErrors}
                    handleFieldErrorChanged={this.handleFieldErrorChanged}
                    className={styles.fullWidth}
                    type={field?.type}
                    needFlex
                    fromToggle
                      {...this.props}
                  />
                  }
                 {field.type=== 'select' && field?.settings?.codeValues
                    && (
                  <>
                    <PulpoField
                      key={field.id}
                      id={field.id}
                      type="string"
                      title={field?.settings?.textForCodedValues}
                      disabled
                      handleValueChange={this.handleAnswerChanged}
                      answer={answers && field?.values[answers[field.id]]?.coded_value}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                    />
                  </>)
                  }
                  {field.type === 'annotation' && field?.annotate_attachment?.length > 0 && field?.annotate_attachment[0]?.url &&(
                    <div style={{ width: '100%' }}>
                      {field.required && <small style={{ color: 'red' }}> * </small> }
                      <span className={styles.field_title}>{field.title}</span>
                      <Annotations imgSrc={(answers[field.id]?.length > 0 && answers[field.id][0]?.url)
                        ? answers[field.id][0]?.url : field?.annotate_attachment[0]?.url}
                        existingImgSrc={field?.annotate_attachment[0]?.url} existingPaths={answers[field.id] || []}
                        handleFieldErrorChanged={error => this.handleFieldErrorChanged(field.id, error)}
                        handleSavePath={val => this.handleAnswerChanged(val, field.id)} drawMode />
                      {showFormErrors && field?.required && (
                          <small style={{ color: 'red' }}>
                              {(!answers[field?.id] || (answers[field?.id]?.length === 0)) && (
                                <FormattedMessage id="pulpoforms.errors.not_blank" defaultMessage="This field cannot be empty" />
                              )}
                          </small>)}
                    </div>)}
                  {field.type === 'attachments' && (
                    <Attachments
                      {...field}
                      handleAnswerChanged={this.handleAnswerChanged}
                      attachments={answers[field.id]}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                    />
                  )}
      {field?.type === 'dataSourceMultiLevel'
      && field?.dataSourceID === 'ds2' && (
      <MultiLevelLocation
        info={{
        ...answers, global_location: answers?.[field?.id], location: answers?.[field?.id]?.map_loaction || formParent.airport_data.location
        }}
        locationList={formParent?.locations || []}
        onInfoChange={(a, b, c) => this.handleAnswerChanged(b, a, null, c)}
        fieldName={field?.levels}
        withoutDepartments
        locationKey="name"
        withFloorPlan
        fromSMS
        field={field}
        fieldId={field?.id}
        isRequiredTrue={field?.required}
        showFormErrors={showFormErrors}
        handleFieldErrorChanged={(a, b) => this.handleFieldErrorChanged(field?.id, b)}
        singleLocation={false}
        defaultLocation={formParent.airport_data.location}
        location_marked={answers[field?.id]?.location_marked}
        assetRegistry
      />
      )}
                  {field?.type === 'multi_field' && (
                    <MultiColumnGrid
                      currentField={field}
                      handleAnswerChanged={this.handleAnswerChanged}
                      answers={answers}
                      handleUploadAttachments={this.handleUploadAttachments}
                      flexWrap
                      errorListMCG={errorListMCG}
                      showFormErrors={showFormErrors}
                      allFields={customFields}
                      formParent={formParent}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                      isPublic
                    />
                  )}
                  { field?.type === 'multi_level'
                && (
                  <>
                  {/* don't even change the props passing position here,
                        it will raise not displaying or page break issues */}
                  <PulpoField
                    {...field}
                    levels={{
                      level_0: {
                        title: `${field?.title}`
                      },
                      level_1: {
                        title: `${field?.title} 1`
                      },
                      level_2: {
                        title: `${field?.title} 2`
                      }
                    }}
                    title={field?.title}
                    values={typeof field.values === 'object'
                      ?Object.values(field.values).map(item => ({ ...item, name: item.title })):[]}
                    handleValueChange={this.handleAnswerChanged}
                    handleFieldErrorChanged={this.handleFieldErrorChanged}
                    isRequired={requiredMap[field.id]}
                    showFieldErrors={showFormErrors}
                    forFormModule
                    answer={answers && answers[field.id]}
                    type="dataSourceMultiLevel"
                    disabled={disableFields && disableFields[field.id]}
                  />
                  </>)
                }
                  {field.type !== 'header'
                  && field.type !== 'annotation'
                  && field.type !== 'page_break'
                  && field.type !== 'multi_field'
                  && field.type !== 'attachments'
                  && field.type !== 'duration'
                  && field.type !== 'portal_user'
                  && field.type !== 'map_location'
                  && field?.type !== 'toggle'
                  && field.type !== 'signature' && field?.type !== 'ssi_field' && field?.type !== 'multi_level'
                  && !(field?.type === 'dataSourceMultiLevel' && field?.dataSourceID === 'ds2') &&(
                    <PulpoField key={field.id} {...field} onlyTime={TIME_FIELD_TYPES.includes(field.type)}
                      translation={field.title} handleValueChange={this.handleAnswerChanged}
                      isRequired={requiredMap[field.id]} answer={answers[field.id]}
                      showFieldErrors={showFormErrors} handleFieldErrorChanged={this.handleFieldErrorChanged}
                      className={field.full_width ? styles.fullWidth : ''} customField={field?.type !== 'select'}
                      noDefault={(TIME_FIELD_TYPES.includes(field.type)
                        || DATE_SUBMIT_FIELD_TYPES.includes(field.type)) && !field?.default}
                      allDataSources={formParent?.data_sources}
                      customError={errorsList && errorsList[field.id]}
                      publicForm
                      locations={formParent?.locations}
                      datasources={formParent?.generic_datasource}
                      placeHolder={placeHolders && placeHolders[field.id]}
                      type={`${this.handleGetFieldType(field)}`}
                      {...this.getOtherFieldInfo(field)}
                      Badging
                      disabled={disableFields && disableFields[field.id]}
                      customFields={customFields}
                      answers={answers}
                      allFields={customFields}
                    />
                  )}
                  {field?.type === 'duration' && (
                    <PulpoField
                      key={field.id}
                      {...field}
                      translation={`${field?.title} (${field?.duration_fields?.calculationFormat?.name})`}
                      handleValueChange={this.handleAnswerChanged}
                      isRequired={requiredMap[field.id]}
                      answer={answers[field.id]}
                      customError={errorsList && errorsList[field.id]}
                      placeHolder={placeHolders && placeHolders[field.id]}
                      formField
                      fromMeeting
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={this.handleFieldErrorChanged}
                      className={field.full_width ? styles.fullWidth : ''}
                      type={field.type}
                      {...this.props}
                      answers={answers}
                      fullWidth={field?.full_width || false}
                    />
                  )}
                  {field.type === 'signature' && (
                    <>
                      <div className={styles.signature}>
                        {field.required && <small style={{ color: 'red' }}> * </small>}
                        <FormattedMessageWithClass
                          className={styles.label} id={field.title}
                          defaultMessage={field.title}
                        />
                        <div style={answers[field.id] && answers[field.id].length ? { display: 'none' } : { display: 'block' }}>
                          <SignatureCanvas
                            ref={(ref) => { this.sigCanvas[field.id] = ref; }}
                            penColor="black"
                            canvasProps={{ width: 778, height: 152, className: styles.sigCanvas }}
                            onEnd={() => this.handleSign(field.id)}
                          />
                        </div>
                        <Button
                          action="tertiary"
                          onClick={() => this.signClear(field.id)}
                          translationID="filters.form.clear"
                          defaultText="clear"
                          className={styles.button}
                        />
                        {showFormErrors && field.required && (
                        <small style={{ color: 'red' }}>
                          {(!answers[field.id] || (answers[field.id].length === 0)) && (
                          <FormattedMessage id="pulpoforms.errors.not_blank"
                            defaultMessage="This field cannot be empty"
                          />
                          )}
                        </small>
                        )}
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          ))}
      </>
    );

    return (
      <>
        <Loading loadingStatus={loadingStatus} />
        {!apiStatus && formParent && Object.keys(formParent).length > 0 && (
          <>
            <div className={styles.title}>
              <img src={formParent?.airport_data?.image} alt="" />
              {!formParent?.form?.settings?.enable_check_public_status_for_workflow_form && <span>{formParent.title}</span>}
            </div>
            <div className={styles.container}>
              <div className={styles.details} style={styleObj}>
              {formParent?.form?.settings?.enable_check_public_status_for_workflow_form && (
                <div className={styles.navBarSty}>
                  <Nav className={styles.tabs}>
                    <NavItem className={styles.NavItem}
                      style={{ paddingRight: '50px' }}
                    >
                      <NavLink
                        className={active_tab === 'form_entry' ? styles.activeLink : ''}
                        onClick={() => this.setState({ active_tab: 'form_entry' })}
                      >
                        <div className={styles.formTitle}>Form Submission</div>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={active_tab === 'form_status' ? styles.activeLink : ''}
                        onClick={() => this.setState({ active_tab: 'form_status' })}
                      >
                        <div className={styles.formTitle}>
                        Form Status
                        </div>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              )}
              {active_tab === 'form_entry' && (
                <div className={styles.fieldsContainer}>
                  {formParent?.form?.settings?.enable_check_public_status_for_workflow_form && (
                      <div className={`${styles.statusCheckTitleName} ${styles.title}`}
                      >
                        <span>{formParent.title}</span>
                      </div>
                  )}
                  <p className={`${styles.instructions} ${styles.break_text}`}>
                    {formParent.additionalInfo}
                  </p>
                  <DefaultFields
                    handleFieldErrorChanged={this.handleFieldErrorChanged}
                    handleAnswerChanged={this.handleAnswerChanged}
                    answers={answers} showFormErrors={showFormErrors}
                    userAttributes={formParent.public_user}
                    disableFields={disableFields}
                  />
                  <div className={styles.details_form}>
                    {requiredMap && sectionHeaders?.length > 0 && customFields?.length > 0
                      && <CollapsibleSections
                          fieldsList={customFields}
                          formatStyle
                          getCustomFieldComponent={getCustomFieldComponent}
                          answers={answers} />}
                    {requiredMap && customFields?.length > 0 && !sectionHeaders?.length
                     && getCustomFieldComponent(customFields) }
                  </div>
                  {customMessage
                    && (
                    <div>
                      <p style={{ color: 'red', textAlign: 'center' }}>{customMessage}</p>
                    </div>
                    )}
                  <div className={styles.footer} style={{ marginTop: 'auto' }}>
                    <Button action="secondary" onClick={this.handleSubmit}
                      translationID="form.submit_form" defaultText="Submit Form"
                      className={styles.formButton}
                    />
                    <span>
                      <a href="https://www.aerosimple.com" target="_blank" rel="noopener noreferrer" className={styles.formAnchor}>
                  Powered by Aerosimple
                      </a>
                    </span>
                  </div>
                </div>
              )}
                {active_tab === 'form_status' && (
                  <>
                    <div className={styles.aligntSty}>
                      <div style={{ padding: '24px' }}>
                        <PulpoField
                          key="search_status" id="search_status" type="string" title="Enter Reference Number"
                          translationID="forms.complete.name"
                          handleValueChange={(a, b) => this.handleSearchFormStatus(a, b)}
                          answer={searchStatusQuery}
                          showFieldErrors={showFormErrors}
                          handleFieldErrorChanged={() => ({})}
                          disabled={disableFields && disableFields.name}
                        />
                      </div>
                      <div>
                        <Button
                          action="secondary"
                          onClick={this.handleSearchQuery}
                          translationID="form.submit.status.query" defaultText="Check Status"
                          className={styles.formButton}
                        />
                      </div>
                    </div>
                    {publicFormData && publicFormData?.order_number ? (
                      <div style={{ padding: '24px' }}>
                        <div className={`${DetailsStyles.stepInfo} ${DetailsStyles.noMarginTop} ${DetailsStyles.publicStatusInfo}`}>
                          <div
                            className={`${DetailsStyles.infoHalf} ${DetailsStyles.halfWidth}
                            ${DetailsStyles?.infoPaddingNone} ${DetailsStyles.publiLabel}`}
                          >
                            <span>Form #</span>
                            <p>
                              {publicFormData?.auto_gen ?? `${publicFormData.order_number}`}
                            </p>
                          </div>
                          <div
                            className={`${DetailsStyles.infoHalf} ${DetailsStyles.halfWidth}
                            ${DetailsStyles?.infoPaddingNone} ${DetailsStyles.publiLabel}`}
                          >
                            <span>Status</span>
                            {publicFormData?.form_process?.status === 'in_progress'
                              ? <>
                                <p>
                                  Pending Approval at
                                  {' '}
                                  {publicFormData?.form_process && publicFormData?.form_process?.current_step
                                  && Object.values(publicFormData?.form_process?.current_step)?.join(', ')}
                                </p>
                                </>
                              : <>
                                <p>
                                  {publicFormData?.form_process?.status === 'complete' && 'Completed'}
                                </p>
                                </>
                            }
                          </div>
                        </div>
                      </div>
                    ): (
                      formStatusMessage && (
                      <div style={{ padding: '24px' }}>
                        <div className={`${DetailsStyles.stepInfo}`}
                          style={{ fontSize: '20px', padding: '24px', justifyContent: 'center' }}
                        >
                          <p>{formStatusMessage}</p>
                        </div>
                      </div>)
                    )}
                  </>
                )}
              </div>
            </div>
          </>
        )}
        {apiStatus && (
        <div className="container">
          <FormSubmitted name={formParent && formParent.title}
            message={message} logo={formParent?.airport_data?.image}
            form_submission_success_msg={form_submission_success_msg}
            ispublicForm
            trackingId={trackingId}
            formParent={formParent}
          />
        </div>
        )}
      </>
    );
  }
}

NewFormAnswer.propTypes = {
  history: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  dataSourceValues: state.inspection.dataSourceValues
});


export default connect(mapStateToProps)(NewFormAnswer);
